import moment from 'moment'

export const CONFIG = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'https://uat-api.oppizi.com/platform',
  API_DASHBOARDS_BASE_URL:
    process.env.REACT_APP_API_DASHBOARDS_BASE_URL ||
    'http://localhost:4000/dev',
  DEVELOPER_API_BASE_URL:
    process.env.REACT_APP_DEVELOPER_API_BASE_URL || 'http://localhost:3800/dev',
  INTEGRATIONS_SERVICE_BASE_URL:
    process.env.REACT_APP_INTEGRATIONS_SERVICE_BASE_URL ||
    'http://localhost:4300/dev',
  GRAPHQL_API_BASE_URL:
    process.env.REACT_APP_GRAPHQL_API_BASE_URL ||
    'https://uat-api.oppizi.com/graphql',
  PATHFINDER_API_BASE_URL:
    process.env.REACT_APP_PATHFINDER_API_BASE_URL || 'http://localhost:5001',
  TRAILBLAZER_API_BASE_URL:
    process.env.REACT_APP_TRAILBLAZER_API_BASE_URL ||
    'http://localhost:5003/graphql',
  SUPERSET_URL: process.env.REACT_APP_SUPERSET_URL || 'http://localhost:8088',
  CAMPAIGN_BUILDER_URL:
    process.env.REACT_APP_CAMPAIGN_BUILDER_URL ||
    'http://localhost:3000/dashboard/campaigns/create?quoteId=QUOTE_ID',
  GOOGLE_API_KEY: 'AIzaSyCXfRmAdsdKRZJGukDU0EbDTpnn98gxztE',
  GOOGLE_API_URL:
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCXfRmAdsdKRZJGukDU0EbDTpnn98gxztE&libraries=geometry',
  GOOGLE_PLACE_URL: ({ latitude, longitude }) =>
    `http://www.google.com/maps/?q=${latitude},${longitude}`,
  FIREBASE: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  },
  TALKJS: {
    appName: process.env.REACT_APP_TALKJS_APP_NAME,
    secretKey: process.env.REACT_APP_TALKJS_SECRET_KEY,
    appID: process.env.REACT_APP_TALKJS_APP_ID,
  },
  SMS: {
    ALLOWED_COUNTRY_CODES: process.env.REACT_APP_SMS_ALLOWED_COUNTRIES,
  },
  SS_BASE_URL: process.env.REACT_APP_SS_BASE_URL || 'http://localhost:3006',
  PAYMENT_BASE_URL:
    process.env.REACT_APP_PAYMENT_BASE_URL || 'http://localhost:9000',
  CRYPTO_SECRET_KEY: process.env.CRYPTO_SECRET_KEY || 'Yp3s6v9y',
  GOOGLE_CAPTCHA:
    process.env.GOOGLE_CAPTCHA || '6Led5lMiAAAAAAwvbxR2Pjy2w7P6KrvJ57Q8b4Yn',
  USER_ROLE: {
    ADMIN: 'ADMIN',
    CITY_MANAGER: 'CITY_MANAGER',
    CLIENT_ADMIN: 'CLIENT_ADMIN',
    CLIENT: 'ROLE_CLIENT',
    DISTRIBUTOR: 'DISTRIBUTOR',
    RECRUITER: 'RECRUITER',
    SPY: 'ROLE_SPY',
  },
  USER_SUBROLE: {
    CITY_MANAGER_ASSISTANT: 'CITY_MANAGER_ASSISTANT',
  },
  SUBROLES: {
    ASSISTANT: 'ASSISTANT',
  },
  STORE: {
    USER_KEY: 'user',
    API_KEY: 'apiKey',
    CHAT_AUTO_OPEN: 'chatOpenedBefore',
    ONBOARDING_ASSISTANT_AUTO_OPEN: 'onboardingAssistantOpenedBefore',
    ONBOARDING_ASSISTANT_ACTIVE_TAB: 'oppizi_assistantActiveTab',
  },
  LOCALE: 'en-US',
  DAY_OF_WEEK_ABBR: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  CUSTOM_LOCALE: 'en-custom',
  COUNTRIES: [
    {
      label: 'Australia',
      value: 'AU',
    },
    {
      label: 'New Zealand',
      value: 'NZ',
    },
  ],
  APPS_FLYER: {
    DEEP_LINK_DOMAIN: process.env.REACT_APP_AF_DEEP_LINK_DOMAIN,
    DEEP_LINK_TEMPLATE_ID: process.env.REACT_APP_AF_DEEP_LINK_TEMPLATE_ID,
  },
  SPREADSHEET: {
    ID:
      process.env.REACT_APP_SPREADSHEET_ID ||
      '1z9-BJCoQI7jBcDsGQK9E4zhCIm4VsLHLGnXsLrR3TB8',
    API_KEY:
      process.env.REACT_APP_SPREADSHEET_API_KEY ||
      'AIzaSyDvHnaUBXu7aj9GVIwTvoedkSUj9mAVrhQ',
  },
  NEXT_BASE_URL: process.env.REACT_APP_NEXT_BASE_URL || 'http://localhost:3001',
  POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'dev',
  US_TAXES_ENABLED: 'true',
  OPPIZI_ML_API_URL: getEnvOrThrow('REACT_APP_OPPIZI_ML_API_URL'),
  FLYER_API_URL: process.env.REACT_APP_FLYER_API_URL,
  HARDCODED_DE_PAY_PER_HOUR: process.env.REACT_APP_HARDCODED_DE_PAY_PER_HOUR,
}

function getEnvOrThrow(key) {
  const value = process.env[key]
  if (value) {
    return value
  } else {
    throw Error(`Could not find environment variable: ${key}`)
  }
}

// TODO: Probably remove this
moment.defineLocale(CONFIG.CUSTOM_LOCALE, {
  parentLocale: 'en',
  weekdaysShort: CONFIG.DAY_OF_WEEK_ABBR,
})
